import React, { useState } from "react";
import Container from "./styles";
import Auth from "../../../Auth";

function SSETest() {
  const [number, setNumber] = useState(60);
  const [string, setString] = useState("");

  return (
    <Container>
      <h1>Server Sent Events Test</h1>

      <input type="text" value={number} onChange={e => setNumber(e.target.value)} /> <br/>

      <button onClick={(e) => {
        setString("");

        Auth.streamWithIdToken("/api/sse-test", {
          number
        }, null, (chunk) => {
          console.log(chunk);

          setString(prevString => prevString + " " + chunk.number);
        });
      }}>Test</button>
<br/><br/>
      <div>
      {string}
      </div>
    </Container>
  );
}

export default SSETest;
